module.exports = "/legacy/8b356f3d39d3f1f3ee206f9ac35b920d.svg";